const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class SalesService {
  getAuthToken() {
    return localStorage.getItem('token');
  }

  getHeaders() {
    const token = this.getAuthToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  // Obtener todas las ventas
  async getSales(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      // Agregar parámetros de paginación
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Agregar parámetros de filtro
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.client) queryParams.append('client', params.client);
      if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
      if (params.dateTo) queryParams.append('dateTo', params.dateTo);
      
      const response = await fetch(`${API_BASE_URL}/api/sales?${queryParams}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getSales:', error);
      throw error;
    }
  }

  // Obtener una venta por ID
  async getSaleById(saleId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/sales/${saleId}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getSaleById:', error);
      throw error;
    }
  }

  // Crear nueva venta
  async createSale(saleData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/sales`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(saleData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en createSale:', error);
      throw error;
    }
  }

  // Actualizar venta
  async updateSale(saleId, saleData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/sales/${saleId}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify(saleData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en updateSale:', error);
      throw error;
    }
  }

  // Eliminar venta
  async deleteSale(saleId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/sales/${saleId}`, {
        method: 'DELETE',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en deleteSale:', error);
      throw error;
    }
  }

  // Obtener estadísticas de ventas
  async getSalesStats(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
      if (params.dateTo) queryParams.append('dateTo', params.dateTo);
      if (params.client) queryParams.append('client', params.client);
      
      const response = await fetch(`${API_BASE_URL}/api/sales/stats?${queryParams}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getSalesStats:', error);
      throw error;
    }
  }

  // Cambiar estado de venta
  async updateSaleStatus(saleId, status) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/sales/${saleId}/status`, {
        method: 'PATCH',
        headers: this.getHeaders(),
        body: JSON.stringify({ status }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en updateSaleStatus:', error);
      throw error;
    }
  }

  // Obtener ventas por cliente
  async getSalesByClient(clientId, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      
      const response = await fetch(`${API_BASE_URL}/api/sales/client/${clientId}?${queryParams}`, {
        method: 'GET',
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error en getSalesByClient:', error);
      throw error;
    }
  }
}

export default new SalesService();
